import { SystemTag, TagOwnershipType } from '@ui/shared/model';
import { ImmomioTagColor } from './immomio-tag-color';

export interface TagConfig {
  label?: string;
  color: ImmomioTagColor;
  tooltip?: string;
}

interface TagConfigs {
  [key: string]: TagConfig;
}

export const TAG_CONFIGS: TagConfigs = {
  [SystemTag.VERIFIED]: {
    label: 'tag.verified_label_l',
    color: SystemTag.VERIFIED,
    tooltip: 'tag.verified_tooltip'
  },
  [SystemTag.GUEST]: {
    label: 'tag.guest_label_l',
    color: SystemTag.GUEST,
    tooltip: 'tag.guest_tooltip'
  },
  [SystemTag.EXCLUSIVE]: {
    label: 'tag.itp_label_l',
    color: SystemTag.EXCLUSIVE,
    tooltip: 'tag.itp_tooltip'
  },
  [SystemTag.OFFLINE]: {
    label: 'tag.offline_label_l',
    color: SystemTag.OFFLINE,
    tooltip: 'tag.offline_tooltip'
  },
  [SystemTag.TENANT]: {
    label: 'tag.tenant_label_l',
    color: SystemTag.TENANT,
    tooltip: 'tag.tenant_tooltip'
  },
  [SystemTag.ANONYMOUS]: {
    label: 'tag.anonymous_label_l',
    color: SystemTag.ANONYMOUS,
    tooltip: 'tag.anonymous_tooltip'
  },
  [SystemTag.CS_PRO]: {
    label: 'tag.cs_pro_label_l',
    color: SystemTag.CS_PRO,
    tooltip: 'tag.cs_pro_tooltip'
  },
  [SystemTag.SALES_PROSPECT]: {
    label: 'tag.sales_prospect_label_l',
    color: SystemTag.SALES_PROSPECT,
    tooltip: 'tag.sales_prospect_tooltip'
  },
  [SystemTag.BUYER]: {
    label: 'tag.buyer_label_l',
    color: SystemTag.BUYER,
    tooltip: 'tag.buyer_tooltip'
  },
  [SystemTag.MEMBER]: {
    label: 'tag.member_label_l',
    color: SystemTag.MEMBER,
    tooltip: 'tag.member_tooltip'
  },
  [SystemTag.SELF_REGISTERED]: {
    label: 'tag.self_registered_label_l',
    color: SystemTag.SELF_REGISTERED,
    tooltip: 'tag.self_registered_tooltip'
  },
  [SystemTag.MERGE_CASE]: {
    label: 'tag.merge_case_label_l',
    color: SystemTag.MERGE_CASE,
    tooltip: 'tag.merge_case_tooltip'
  },
  [TagOwnershipType.SHARED]: {
    color: TagOwnershipType.SHARED
  },
  [TagOwnershipType.PERSONAL]: {
    color: TagOwnershipType.PERSONAL
  },
  [TagOwnershipType.DYNAMIC]: {
    color: TagOwnershipType.DYNAMIC
  },
  ['PROJECT']: {
    color: 'project'
  }
};
